import PopoverSystemV2 from './PopoverSystemV2';
import './PopoverSystemV2.scss';

export default PopoverSystemV2;
